"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * The UserAttributes model module.
 * @module model/UserAttributes
 * @version 1.0.0
 */
var UserAttributes = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>UserAttributes</code>.
   * @alias module:model/UserAttributes
   */
  function UserAttributes() {
    _classCallCheck(this, UserAttributes);

    UserAttributes.initialize(this);
  }
  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */


  _createClass(UserAttributes, null, [{
    key: "initialize",
    value: function initialize(obj) {}
    /**
     * Constructs a <code>UserAttributes</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/UserAttributes} obj Optional instance to populate.
     * @return {module:model/UserAttributes} The populated <code>UserAttributes</code> instance.
     */

  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new UserAttributes();

        if (data.hasOwnProperty('id')) {
          obj['id'] = _ApiClient.default.convertToType(data['id'], 'Number');
        }

        if (data.hasOwnProperty('first_name')) {
          obj['first_name'] = _ApiClient.default.convertToType(data['first_name'], 'String');
        }

        if (data.hasOwnProperty('last_name')) {
          obj['last_name'] = _ApiClient.default.convertToType(data['last_name'], 'String');
        }

        if (data.hasOwnProperty('company')) {
          obj['company'] = _ApiClient.default.convertToType(data['company'], 'String');
        }

        if (data.hasOwnProperty('job_title')) {
          obj['job_title'] = _ApiClient.default.convertToType(data['job_title'], 'String');
        }

        if (data.hasOwnProperty('email')) {
          obj['email'] = _ApiClient.default.convertToType(data['email'], 'String');
        }

        if (data.hasOwnProperty('status')) {
          obj['status'] = _ApiClient.default.convertToType(data['status'], 'String');
        }

        if (data.hasOwnProperty('role')) {
          obj['role'] = _ApiClient.default.convertToType(data['role'], 'String');
        }

        if (data.hasOwnProperty('token')) {
          obj['token'] = _ApiClient.default.convertToType(data['token'], 'String');
        }
      }

      return obj;
    }
  }]);

  return UserAttributes;
}();
/**
 * @member {Number} id
 */


UserAttributes.prototype['id'] = undefined;
/**
 * @member {String} first_name
 */

UserAttributes.prototype['first_name'] = undefined;
/**
 * @member {String} last_name
 */

UserAttributes.prototype['last_name'] = undefined;
/**
 * @member {String} company
 */

UserAttributes.prototype['company'] = undefined;
/**
 * @member {String} job_title
 */

UserAttributes.prototype['job_title'] = undefined;
/**
 * @member {String} email
 */

UserAttributes.prototype['email'] = undefined;
/**
 * @member {String} status
 */

UserAttributes.prototype['status'] = undefined;
/**
 * @member {String} role
 */

UserAttributes.prototype['role'] = undefined;
/**
 * @member {String} token
 */

UserAttributes.prototype['token'] = undefined;
var _default = UserAttributes;
exports.default = _default;